import { useState } from 'react'

import ToastService from 'services/toast.service'
import FolderService from 'services/folder.service'

import { PatchFolderItemType } from 'types/folders'
import { useActionless } from 'redux/hooks'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import FolderTree from 'components/misc/NewDeckModal/FolderTree'
import PhatButton from 'components/formElements/PhatButton'

import styles from './moveToArbitraryFolderOverlay.module.scss'

type Props = {
  deckIds?: (string | number)[]

  open: boolean
  onClose: () => void
}

const MoveToArbitraryFolderOverlay = ({ open, onClose, deckIds = [] }: Props) => {
  const [moveToFolderId, setMoveToFolderId] = useState<null | number>(null)
  const [loading, setLoading] = useState(false)

  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  const handleMoveItemsToSelectedFolder = () => {
    if (!moveToFolderId) return ToastService.create('Select a folder to move items to', 'Folder Service', 'warning')

    setLoading(true)

    const itemsToUpdate: PatchFolderItemType[] = deckIds.map(id => ({
      type: 'deck',
      id: Number(id),
      patch: { parentFolder: moveToFolderId },
    }))

    return FolderService.updateItems(itemsToUpdate)
      .then(() => FolderService.details())
      .then(rootFolder => {
        setFolderState({ rootFolder })

        onClose()
      })
      .catch(ToastService.create)
      .finally(() => setLoading(false))
  }

  return (
    <GlobalOverlayStack open={open} onClose={onClose}>
      <div className={styles.container}>
        <h2>Move items to arbitrary folder</h2>
        <p>
          NOTE: Moving items to an arbitrary folder with ONLY MOVE DECKS. This is to prevent users from creating a
          cyclical folder structure.
        </p>

        <div className={styles.folderTree}>
          <FolderTree setFolderId={setMoveToFolderId} />
        </div>

        <div className={styles.controls}>
          <PhatButton disabled={loading} color="green" onClick={handleMoveItemsToSelectedFolder}>
            Move all ({deckIds.length}) items
          </PhatButton>
        </div>
      </div>
    </GlobalOverlayStack>
  )
}

export default MoveToArbitraryFolderOverlay
